import type { SickNoteStep } from "~/modules/absence/utils/sickNoteSteps.ts";

type Props = {
	steps: SickNoteStep[];
};

export function StepList({ steps }: Props) {
	return (
		<ol className="space-y-2">
			{steps.map((step, index) => (
				<li key={step.title} className="flex items-start gap-3">
					<span aria-hidden
						  className="flex size-5 shrink-0 items-center justify-center rounded-full bg-primary-500 text-xs font-semibold text-white">
						{index + 1}
					</span>
					<p className="min-w-0 flex-1 text-xs text-gray-900">{step.title}</p>
				</li>
			))}
		</ol>
	);
}
